import React from 'react';
import {
  bool, func, string,
} from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Button, Flex, Typography, Icon, Modal, Input, Checkbox,
} from '@atoms';
import { ImageUploader, DeleteModal } from '@molecules';
import { ReactComponent as Close } from '@assets/remove-item.svg';

const ValueProcessModal = ({
  onValueDelete,
  IsValueDeleteModalOpen,
  onValueDeleteModalChangeState,
  isEditing,
  onValueEditSubmit,
  onValueImageChange,
  onValueNameChange,
  onValuePreselectedStateChange,
  onValuePriceChange,
  valueName,
  isValuePreselected,
  valuePrice,
  valueImage,
  onModalClose,
  isModalOpen,
}) => (
  <Modal
    onTop
    isOpen={isModalOpen}
    ariaHideApp={false}
    onRequestClose={onModalClose}
    shouldCloseOnOverlayClick
  >
    <ButtonClose primary onClick={onModalClose}>
      <Flex justifyCenter itemsCenter>
        <Icon SVG={Close} width="20px" height="20px" />
      </Flex>
    </ButtonClose>
    <Typography marginLeft="lg" size="xl4" weight="black">Option Value</Typography>
    <Input
      marginTop="xl2"
      type="text"
      id="valueName"
      name="valueName"
      placeholder="Value name"
      value={valueName}
      onChange={onValueNameChange}
      data-cy="valueName"
    />
    <Input
      marginTop="xl5"
      type="text"
      id="valuePrice"
      name="valuePrice"
      value={`$${valuePrice}`}
      onChange={onValuePriceChange}
      data-cy="valuePrice"
    />
    <ImageContainer column itemsCenter marginTop="xl">
      <ImageUploader
        image={valueImage}
        onImageChange={onValueImageChange}
      />
    </ImageContainer>
    <Flex marginTop="xl5" itemsCenter justifyCenter>
      <Checkbox onCheckedStateChange={onValuePreselectedStateChange} isChecked={isValuePreselected} />
      <Typography marginLeft="lg" size="xl" weight="black">Is value preselected?</Typography>
    </Flex>
    {isEditing && (
      <Button.Rectangular
        marginTop="xl"
        onClick={onValueDeleteModalChangeState}
        primary
        padding="lg"
      >
        Delete
      </Button.Rectangular>
    )}
    <Button.Rectangular
      fullWidth
      primary
      padding="xl"
      onClick={onValueEditSubmit}
      marginTop="xl5"
      disabled={!valueName}
    >
      <Typography size="lg">
        Confirm
      </Typography>
    </Button.Rectangular>
    <DeleteModal
      name={valueName}
      isModalOpen={IsValueDeleteModalOpen}
      onModalClose={onValueDeleteModalChangeState}
      onDelete={onValueDelete}
    />
  </Modal>
);

const ButtonClose = styled(Button.Circular)`
  ${({ theme: { spacing } }) => css`
    padding: ${spacing.xs};
    position: absolute;
    top: 10px;
    right: 10px;
  `}
`;

const ImageContainer = styled(Flex)`
`;

ValueProcessModal.propTypes = {
  onValueDelete: func.isRequired,
  IsValueDeleteModalOpen: bool.isRequired,
  onValueDeleteModalChangeState: func.isRequired,
  onValueEditSubmit: func.isRequired,
  isEditing: bool.isRequired,
  valueName: string.isRequired,
  valuePrice: string.isRequired,
  onValueImageChange: func.isRequired,
  onValueNameChange: func.isRequired,
  onValuePreselectedStateChange: func.isRequired,
  onValuePriceChange: func.isRequired,
  isValuePreselected: bool.isRequired,
  valueImage: string.isRequired,
  onModalClose: func.isRequired,
  isModalOpen: bool.isRequired,
};

export default ValueProcessModal;
